import * as i18next from 'i18next'
import { Range } from 'immutable'
import React, { ReactNode } from 'react'
import { TeamMember } from './aboutUs.state'

export const AboutUsLayout = {
  TeamMembersCards: (props: { teamMembers: Array<TeamMember> }) => {
    return (
      <section className="mw-container-m mx-auto page px-gutter">
        <ul className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-gutter g-lg-gutter-l">
          {Range(0, props.teamMembers.length / 3 + (props.teamMembers.length % 3) == 0 ? 1 : 2)
            .map<ReactNode>((i) => {
              const tm1 = props.teamMembers[i * 3 + 0]
              const tm2 = props.teamMembers[i * 3 + 1]
              const tm3 = props.teamMembers[i * 3 + 2]
              return <>
                {tm1 != undefined ? (
                  <AboutUsLayout.TeamMemberCard teamMember={tm1} />
                ) : undefined}
                {tm2 != undefined ? (
                  <AboutUsLayout.TeamMemberCard teamMember={tm2} />
                ) : undefined}
                {tm3 != undefined? (
                  <AboutUsLayout.TeamMemberCard teamMember={tm3} />
                ) : undefined}
              </>
            })
            .toArray()}
        </ul>
      </section>
    )
  },
  TeamMemberCard: (props: { teamMember: TeamMember }) => (
    <li className="col d-flex flex-column">
      <div className="card border-0 rounded-0 h-100">
        <img src={props.teamMember.ImageURL} className="w-100" width="320" height="400" loading="lazy" />

        <div className="card-body bg-secondary px-gutter-l py-5">
          <p className="card-text small text-primary text-uppercase">
            {i18next.default.t<string>(`global:${props.teamMember.CompanyRole}`)}
          </p>
          <h2 className="card-text text-white">
            {props.teamMember.Name} {props.teamMember.Surname}
          </h2>
        </div>
      </div>
    </li>
  ),
}
